/* eslint-disable */
/**
 * This file was automatically generated by GraphQL Code Generator.
 * Do not make changes to this file as they will be lost when the code is regenerated.
 */

import {
  AchievementGroup,
  AchievementType,
  AdapterType,
  AppListingStore,
  AssetStatus,
  AudioAnchor,
  AutoTrainingIneligibilityReason,
  AutoTrainingType,
  BillingPeriod,
  BlueprintInputObjectType,
  BlueprintObjectType,
  BlueprintRunStatus,
  BlueprintValidationErrorCode,
  BlueprintValueReferenceType,
  BlueprintVersionStatus,
  CanvasObjectType,
  ConsentStatus,
  CreativeUnitTransferType,
  ErrorType,
  EventName,
  EventResourceType,
  EventType,
  ExportAssetFormat,
  ExportCompressionLevel,
  ExportFileFormat,
  ExportVideoCodec,
  FileContentCategory,
  FileRefinementType,
  FileReportType,
  FileStatus,
  GenerationType,
  GetBlueprintRunStepIdType,
  GetWorkspaceBlueprintsInputScope,
  GetWorkspaceStyleInputIdType,
  GoogleDriveKind,
  GoogleDriveObjectTypeFilter,
  GuidanceFileType,
  InferenceErrorCode,
  InferenceQuality,
  InferenceStatus,
  Intent,
  LabelStatus,
  LibraryObjectStatus,
  LibraryObjectTypeFilter,
  LibraryScope,
  LoginStrategy,
  Modality,
  ObjectVisibility,
  OnBlueprintExecutionEventInputIdType,
  OnInferenceProgressInputIdType,
  OnTrainingRunProgressInputIdType,
  OnboardingCompletionSource,
  OnboardingUserType,
  PackageType,
  PlanTier,
  PreprocessImageAnnotator,
  ProjectIntegrationTargetKind,
  ProjectObjectLinkStatus,
  ProjectObjectLinkType,
  ProjectObjectTypeFilter,
  ProjectStatus,
  PushProvider,
  ReferenceSetCompatibilityTag,
  SegmentLevel,
  SegmentTarget,
  SessionCanvasObjectEventType,
  SessionFormType,
  SessionInferenceMode,
  SessionObjectEventType,
  SessionObjectTypeFilter,
  SessionStatus,
  SessionTemplateExploreSection,
  SessionTemplateStatus,
  ShortcutTargetType,
  SkillResourceKind,
  SortingDirection,
  SourceType,
  SsoConnectionStatus,
  SsoConnectionStrategy,
  StyleAutoPopulationAttribute,
  StyleCanForgeFromStatus,
  StyleCategory,
  StyleContentType,
  StyleFinetuneStatus,
  StyleInputFileType,
  StyleStatus,
  StyleType,
  StyleTypeFilter,
  ThinkingLevel,
  TrainingCategory,
  TrainingFramework,
  TrainingMethod,
  TrainingRunStatus,
  UsageLimitPeriod,
  UsageLimitStatus,
  VectorizationColorMode,
  VectorizationMode,
  VideoEffectType,
  WorkspaceDomainStatus,
  WorkspaceIntegrationProvider,
  WorkspaceIntegrationStatus,
  WorkspaceMembershipStatus,
  WorkspaceRole,
  WorkspaceUsageGroupBy,
} from "./schema.graphql.d";
export const ACHIEVEMENT_GROUP: AchievementGroup[] = [
  "GRID",
  "INVITE",
  "JOURNEY",
  "ONGOING",
];
export const ACHIEVEMENT_TYPE: AchievementType[] = [
  "BOOLEAN",
  "COUNT",
  "SUM",
  "TIERED",
];
export const ADAPTER_TYPE: AdapterType[] = ["LORA", "VOICE_EMBEDDING"];
export const APP_LISTING_STORE: AppListingStore[] = [
  "APP_STORE",
  "PLAY_STORE",
  "STEAM",
];
export const ASSET_STATUS: AssetStatus[] = ["ACTIVE", "ARCHIVED", "DELETED"];
export const AUDIO_ANCHOR: AudioAnchor[] = ["END", "START"];
export const AUTO_TRAINING_INELIGIBILITY_REASON: AutoTrainingIneligibilityReason[] =
  ["NOT_ENOUGH_IMAGES", "NO_ALLOWED_BASE_MODEL"];
export const AUTO_TRAINING_TYPE: AutoTrainingType[] = [
  "IMAGE_EDIT",
  "TEXT_TO_IMAGE",
];
export const BILLING_PERIOD: BillingPeriod[] = ["MONTH", "YEAR"];
export const BLUEPRINT_INPUT_OBJECT_TYPE: BlueprintInputObjectType[] = [
  "INPUT",
  "NODE",
];
export const BLUEPRINT_OBJECT_TYPE: BlueprintObjectType[] = [
  "EDGE",
  "INPUT",
  "NODE",
  "OUTPUT",
];
export const BLUEPRINT_RUN_STATUS: BlueprintRunStatus[] = [
  "CANCELLED",
  "FAILURE",
  "PAUSED",
  "PENDING",
  "RUNNING",
  "SUCCESS",
];
export const BLUEPRINT_VALIDATION_ERROR_CODE: BlueprintValidationErrorCode[] = [
  "CIRCULAR_REFERENCE",
  "DISCONNECTED_GRAPH",
  "EMPTY_GRAPH",
  "INCOMPATIBLE_TYPES",
  "INVALID_INPUT",
  "INVALID_REFERENCE",
  "UNSATISFIED_INPUT",
];
export const BLUEPRINT_VALUE_REFERENCE_TYPE: BlueprintValueReferenceType[] = [
  "BLUEPRINT_PARAMETER",
  "NODE_PORT",
];
export const BLUEPRINT_VERSION_STATUS: BlueprintVersionStatus[] = [
  "ARCHIVED",
  "DRAFT",
  "PUBLISHED",
];
export const CANVAS_OBJECT_TYPE: CanvasObjectType[] = [
  "BLUEPRINT",
  "BLUEPRINT_RUN",
  "GROUP",
  "LIBRARY_OBJECT",
  "TEXT",
  "TREND",
];
export const CONSENT_STATUS: ConsentStatus[] = [
  "ACCEPTED",
  "NOT_SET",
  "REFUSED",
];
export const CREATIVE_UNIT_TRANSFER_TYPE: CreativeUnitTransferType[] = [
  "AUTO",
  "MANUAL",
];
export const ERROR_TYPE: ErrorType[] = [
  "BAD_REQUEST_ERROR",
  "FORBIDDEN_ERROR",
  "INTERNAL_SERVER_ERROR",
  "NOT_FOUND_ERROR",
  "PAYMENT_REQUIRED_ERROR",
  "RATE_LIMITED_ERROR",
  "UNAUTHORIZED_ERROR",
];
export const EVENT_NAME: EventName[] = [
  "ACHIEVEMENT_CLAIMED",
  "ACHIEVEMENT_EARNED",
  "ASSET_CREATED",
  "ASSET_DELETED",
  "ASSET_DUPLICATED",
  "ASSET_EXPORTED",
  "ASSET_FEATURED_IN_STYLE",
  "ASSET_FORGED",
  "ASSET_MOVED",
  "ASSET_POSTED_TO_STYLE",
  "ASSET_REFINED",
  "ASSET_RENAMED",
  "ASSET_UPDATED",
  "BILLING_PURCHASE_COMPLETED",
  "BLUEPRINT_ADDED_TO_WORKSPACE",
  "BLUEPRINT_CREATED",
  "BLUEPRINT_DELETED",
  "BLUEPRINT_PUBLISHED",
  "BLUEPRINT_REMOVED_FROM_WORKSPACE",
  "BLUEPRINT_RUN_FINISHED",
  "DIRECTORY_CREATED",
  "DIRECTORY_DELETED",
  "DIRECTORY_MOVED",
  "DIRECTORY_UPDATED",
  "FILES_EXPORTED",
  "FILES_ZIPPED",
  "FILE_DELETED",
  "FILE_LIKED",
  "FILE_MOVED",
  "FILE_REPORTED",
  "FILE_UNLIKED",
  "FILE_UPDATED",
  "FILE_UPLOADED",
  "GOOGLE_DRIVE_FILES_IMPORTED",
  "LABEL_ARCHIVED",
  "LABEL_UNARCHIVED",
  "PROJECT_ARCHIVED",
  "PROJECT_CREATED",
  "PROJECT_DELETED",
  "PROJECT_OBJECT_LINKED",
  "PROJECT_OBJECT_UNLINKED",
  "PROJECT_SESSION_LINKED",
  "PROJECT_UNARCHIVED",
  "REFERENCE_SET_CREATED",
  "REFERENCE_SET_DUPLICATED",
  "REFERENCE_SET_REFERENCED_IN_GENERATION",
  "SESSION_ARCHIVED",
  "SESSION_CREATED",
  "SESSION_DELETED",
  "SESSION_UNARCHIVED",
  "SHORTCUT_CREATED",
  "SHORTCUT_DELETED",
  "SHORTCUT_UPDATED",
  "SKILL_CREATED",
  "SKILL_UPDATED",
  "STYLE_ACTIVE_FINETUNE_SET",
  "STYLE_ADDED_TO_WORKSPACE",
  "STYLE_ARCHIVED",
  "STYLE_CREATED",
  "STYLE_DELETED",
  "STYLE_DUPLICATED",
  "STYLE_LIKED",
  "STYLE_MOVED",
  "STYLE_REMOVED_FROM_WORKSPACE",
  "STYLE_TRAINING_CANCELLED",
  "STYLE_TRAINING_COMPLETED",
  "STYLE_TRAINING_FAILED",
  "STYLE_TRAINING_STARTED",
  "STYLE_UNARCHIVED",
  "STYLE_UPDATED",
  "SUBSCRIPTION_CANCELLED",
  "UNITS_CONSUMED",
  "USER_ACTIVATED",
  "USER_ACTIVE_WORKSPACE_SET",
  "USER_CREATED",
  "USER_DELETED",
  "USER_INVITED",
  "USER_ROLE_UPDATED",
  "USER_SUSPENDED",
  "USER_UPDATED",
  "VIDEO_TIMELINE_RENDER_FINISHED",
  "WORKSPACE_BILLING_LINK_CREATED",
  "WORKSPACE_BILLING_UPDATED",
  "WORKSPACE_CREATED",
  "WORKSPACE_DELETED",
  "WORKSPACE_GROUP_MEMBERSHIP_CREATED",
  "WORKSPACE_GROUP_MEMBERSHIP_UPDATED",
  "WORKSPACE_INTEGRATION_CREATED",
  "WORKSPACE_INTEGRATION_DELETED",
  "WORKSPACE_INTEGRATION_SCOPE_CLEARED",
  "WORKSPACE_INTEGRATION_SCOPE_SET",
  "WORKSPACE_METERED_BILLING_CHECKOUT_LINK_CREATED",
  "WORKSPACE_METERED_BILLING_PORTAL_LINK_CREATED",
  "WORKSPACE_SEAT_COUNT_UPDATED",
  "WORKSPACE_UPDATED",
];
export const EVENT_RESOURCE_TYPE: EventResourceType[] = [
  "ACHIEVEMENT",
  "BLUEPRINT",
  "CANVAS",
  "DIRECTORY",
  "FILE",
  "INFERENCE",
  "LABEL",
  "PROJECT",
  "SESSION",
  "SHORTCUT",
  "SKILL",
  "STYLE",
  "USAGE",
  "USER",
  "WORKSPACE",
  "WORKSPACE_INTEGRATION",
  "WORKSPACE_MEMBERSHIP",
];
export const EVENT_TYPE: EventType[] = [
  "ACHIEVEMENT",
  "ASSET",
  "BLUEPRINT",
  "DIRECTORY",
  "FILE",
  "LABEL",
  "PROJECT",
  "SESSION",
  "SHORTCUT",
  "SKILL",
  "STYLE",
  "USAGE",
  "USER",
  "WORKSPACE",
];
export const EXPORT_ASSET_FORMAT: ExportAssetFormat[] = ["PSD", "ZIP"];
export const EXPORT_COMPRESSION_LEVEL: ExportCompressionLevel[] = [
  "HIGH",
  "NORMAL",
];
export const EXPORT_FILE_FORMAT: ExportFileFormat[] = [
  "GIF",
  "GLTF",
  "JPEG",
  "MOV",
  "MP4",
  "OBJ",
  "PNG",
  "PSD",
  "WEBM",
];
export const EXPORT_VIDEO_CODEC: ExportVideoCodec[] = ["H264", "H265"];
export const FILE_CONTENT_CATEGORY: FileContentCategory[] = [
  "AUDIO",
  "IMAGE",
  "MESH",
  "OTHER",
  "PLAYABLE",
  "POSE",
  "SAFETENSORS",
  "SPINE",
  "VIDEO",
];
export const FILE_REFINEMENT_TYPE: FileRefinementType[] = [
  "CROP",
  "EXPAND",
  "ORIGINAL",
  "REMOVE_BACKGROUND",
  "REMOVE_OBJECTS",
  "SEGMENTATION",
  "UPSCALE_ESRGAN",
  "UPSCALE_ESRGAN_FACE_CORRECTION",
  "UPSCALE_STYLE",
];
export const FILE_REPORT_TYPE: FileReportType[] = [
  "BAD_QUALITY",
  "HATE_SPEECH",
  "IP_INFRINGEMENT",
  "NUDITY",
  "OTHER",
  "SPAM",
  "VIOLENCE",
];
export const FILE_STATUS: FileStatus[] = [
  "DELETED",
  "FAILED_PROCESSING",
  "PENDING",
  "PROCESSED",
  "UPLOADED",
];
export const GENERATION_TYPE: GenerationType[] = [
  "ANIMATE_MESH",
  "BLUEPRINT",
  "CREATE",
  "EDIT",
  "IMAGE_TO_3D",
  "IMAGE_TO_VIDEO",
  "LIP_SYNC",
  "REALTIME",
  "REFILL",
  "REMOVE_BACKGROUND",
  "SOUND_EFFECT",
  "TEXT_TO_3D",
  "TEXT_TO_SPEECH",
  "UPSCALE",
  "UPSCALE_VIDEO",
  "VECTORIZE_IMAGE",
];
export const GET_BLUEPRINT_RUN_STEP_ID_TYPE: GetBlueprintRunStepIdType[] = [
  "NODE_ID",
  "STEP_ID",
];
export const GET_WORKSPACE_BLUEPRINTS_INPUT_SCOPE: GetWorkspaceBlueprintsInputScope[] =
  ["ALL", "DISCOVERY", "EXECUTION"];
export const GET_WORKSPACE_STYLE_INPUT_ID_TYPE: GetWorkspaceStyleInputIdType[] =
  ["ID", "SLUG"];
export const GOOGLE_DRIVE_KIND: GoogleDriveKind[] = [
  "MY_DRIVE",
  "SHARED_DRIVE",
];
export const GOOGLE_DRIVE_OBJECT_TYPE_FILTER: GoogleDriveObjectTypeFilter[] = [
  "FILE",
  "FOLDER",
];
export const GUIDANCE_FILE_TYPE: GuidanceFileType[] = [
  "AUDIO",
  "CANNY",
  "COLOR_SKETCH",
  "DEPTH",
  "EDITING_REFERENCE",
  "ELEMENT_FRONTAL_IMAGE",
  "ELEMENT_REFERENCE_IMAGE",
  "ELEMENT_VIDEO",
  "FACE",
  "FIRST_FRAME",
  "INIT",
  "INIT_AUDIO",
  "INIT_MESH",
  "INIT_VIDEO",
  "LAST_FRAME",
  "LINEART",
  "POSE",
  "PROMPT",
  "REFERENCE_IMAGE",
  "REFERENCE_VIDEO",
  "SCRIBBLE",
  "SEGMENTATION",
  "SOFTEDGE_HED",
  "TEXTURE_IMAGE",
];
export const INFERENCE_ERROR_CODE: InferenceErrorCode[] = [
  "BALANCE_UNAVAILABLE",
  "CONTENT_POLICY_VIOLATION",
  "DOWNSTREAM_SERVICE_CLIENT_ERROR",
  "DOWNSTREAM_SERVICE_ERROR",
  "DOWNSTREAM_SERVICE_SERVER_ERROR",
  "IMAGE_TOO_LARGE",
  "IMAGE_TOO_SMALL",
  "INSUFFICIENT_BALANCE",
  "INTERNAL_SERVER_ERROR",
  "INVALID_IMAGE_SIZE",
  "INVALID_INPUTS_ERROR",
  "MODEL_CAPABILITY_MISMATCH",
  "NO_MEDIA_GENERATED",
  "PROMPT_INTELLECTUAL_PROPERTY",
  "VIDEO_TOO_LARGE",
  "VIDEO_TOO_LONG",
  "VIDEO_TOO_SHORT",
  "VIDEO_TOO_SMALL",
];
export const INFERENCE_QUALITY: InferenceQuality[] = ["HIGH", "LOW", "MEDIUM"];
export const INFERENCE_STATUS: InferenceStatus[] = [
  "CANCELLED",
  "COMPLETE",
  "DELETED",
  "FAILED",
  "IN_PROGRESS",
];
export const INTENT: Intent[] = ["EXPORT_ASSET"];
export const LABEL_STATUS: LabelStatus[] = ["ACTIVE", "ARCHIVED"];
export const LIBRARY_OBJECT_STATUS: LibraryObjectStatus[] = [
  "DRAFT",
  "FAILED",
  "PROCESSING",
  "READY",
];
export const LIBRARY_OBJECT_TYPE_FILTER: LibraryObjectTypeFilter[] = [
  "ASSET",
  "FILE",
  "REFERENCE_SET",
  "SKILL",
  "STYLE",
];
export const LIBRARY_SCOPE: LibraryScope[] = [
  "FEATURED",
  "SHARED",
  "WORKSPACE",
];
export const LOGIN_STRATEGY: LoginStrategy[] = [
  "APPLE",
  "EMAIL_OTP",
  "EMAIL_PASSWORD",
  "GOOGLE",
  "MICROSOFT_ENTRA",
  "OKTA",
  "TWITTER",
];
export const MODALITY: Modality[] = [
  "AUDIO",
  "IMAGE",
  "PLAYABLE",
  "TEXT",
  "THREE_D",
  "VIDEO",
];
export const OBJECT_VISIBILITY: ObjectVisibility[] = ["PRIVATE", "PUBLIC"];
export const ON_BLUEPRINT_EXECUTION_EVENT_INPUT_ID_TYPE: OnBlueprintExecutionEventInputIdType[] =
  ["BLUEPRINT_RUN", "BLUEPRINT_VERSION", "SESSION"];
export const ON_INFERENCE_PROGRESS_INPUT_ID_TYPE: OnInferenceProgressInputIdType[] =
  ["ASSET", "SESSION", "WORKSPACE"];
export const ON_TRAINING_RUN_PROGRESS_INPUT_ID_TYPE: OnTrainingRunProgressInputIdType[] =
  ["STYLE", "TRAINING_RUN"];
export const ONBOARDING_COMPLETION_SOURCE: OnboardingCompletionSource[] = [
  "COMPLETED",
  "SKIPPED",
];
export const ONBOARDING_USER_TYPE: OnboardingUserType[] = [
  "EXPLORER",
  "GAME_ARTIST",
  "NON_ARTIST",
  "OTHER",
];
export const PACKAGE_TYPE: PackageType[] = ["ONE_TIME", "SUBSCRIPTION"];
export const PLAN_TIER: PlanTier[] = ["ENTERPRISE", "FREE", "PRO", "STUDIO"];
export const PREPROCESS_IMAGE_ANNOTATOR: PreprocessImageAnnotator[] = [
  "CANNY",
  "DEPTH",
  "LINEART",
];
export const PROJECT_INTEGRATION_TARGET_KIND: ProjectIntegrationTargetKind[] = [
  "APPLOVIN_APP",
  "DRIVE_FOLDER",
];
export const PROJECT_OBJECT_LINK_STATUS: ProjectObjectLinkStatus[] = [
  "ACTIVE",
  "DELETED",
];
export const PROJECT_OBJECT_LINK_TYPE: ProjectObjectLinkType[] = [
  "LIBRARY_OBJECT",
  "TREND",
];
export const PROJECT_OBJECT_TYPE_FILTER: ProjectObjectTypeFilter[] = [
  "ASSET",
  "BLUEPRINT",
  "DIRECTORY",
  "FILE",
  "REFERENCE_SET",
  "STYLE",
  "TREND",
];
export const PROJECT_STATUS: ProjectStatus[] = [
  "ACTIVE",
  "ARCHIVED",
  "DELETED",
];
export const PUSH_PROVIDER: PushProvider[] = ["APNS", "FCM"];
export const REFERENCE_SET_COMPATIBILITY_TAG: ReferenceSetCompatibilityTag[] = [
  "ANIMATION",
  "LORA",
  "NONE",
  "PROMPT_ONLY",
  "REFERENCES",
  "VOICE",
];
export const SEGMENT_LEVEL: SegmentLevel[] = ["HIGH", "LOW", "MEDIUM"];
export const SEGMENT_TARGET: SegmentTarget[] = ["CHARACTER", "GENERAL"];
export const SESSION_CANVAS_OBJECT_EVENT_TYPE: SessionCanvasObjectEventType[] =
  ["CREATED", "DELETED", "UPDATED"];
export const SESSION_FORM_TYPE: SessionFormType[] = [
  "AUDIO",
  "BLUEPRINT",
  "IMAGE",
  "PLAYABLE",
  "THREE_D",
  "VIDEO",
];
export const SESSION_INFERENCE_MODE: SessionInferenceMode[] = [
  "ADD_SFX_VIDEO",
  "ANIMATE_MESH",
  "BLUEPRINT",
  "CANVAS_2_D",
  "CANVAS_PROMPT_EDIT",
  "CREATE",
  "CREATE_3_D",
  "CREATE_SOUND_EFFECT",
  "CREATE_SPEECH",
  "CREATE_VIDEO",
  "PROMPT_EDIT_IMAGE",
  "PROMPT_EDIT_VIDEO",
  "REALTIME",
  "REFRAME_IMAGE",
  "REFRAME_VIDEO",
  "REMESH",
  "REMOVE_BACKGROUND",
  "REMOVE_BACKGROUND_VIDEO",
  "RETEXTURE_MESH",
  "RIG_MESH",
  "SEGMENT_MESH",
  "SPLIT_IMAGE_INTO_LAYERS",
  "UPSCALE",
  "UPSCALE_VIDEO",
  "VECTORIZE_IMAGE",
];
export const SESSION_OBJECT_EVENT_TYPE: SessionObjectEventType[] = [
  "CREATED",
  "DELETED",
  "UPDATED",
];
export const SESSION_OBJECT_TYPE_FILTER: SessionObjectTypeFilter[] = [
  "ASSET",
  "FILE",
];
export const SESSION_STATUS: SessionStatus[] = [
  "ACTIVE",
  "ARCHIVED",
  "DELETED",
];
export const SESSION_TEMPLATE_EXPLORE_SECTION: SessionTemplateExploreSection[] =
  [
    "AUDIO_GENERATION",
    "IMAGE_GENERATION",
    "MARKETING",
    "THREE_D_GENERATION",
    "VIDEO_GENERATION",
    "WORKFLOWS",
  ];
export const SESSION_TEMPLATE_STATUS: SessionTemplateStatus[] = [
  "DISABLED",
  "ENABLED",
];
export const SHORTCUT_TARGET_TYPE: ShortcutTargetType[] = [
  "BASE_MODEL",
  "PROJECT",
  "REFERENCE_SET",
  "SESSION",
  "WORKFLOW",
];
export const SKILL_RESOURCE_KIND: SkillResourceKind[] = ["ASSET", "REFERENCE"];
export const SORTING_DIRECTION: SortingDirection[] = ["ASC", "DESC"];
export const SOURCE_TYPE: SourceType[] = [
  "COMPOSITE",
  "MASK",
  "POSE",
  "REFERENCE",
  "SKILL_RESOURCE",
  "TRANSFORMED_REFERENCE",
];
export const SSO_CONNECTION_STATUS: SsoConnectionStatus[] = [
  "ACTIVE",
  "FAILED",
  "PENDING_SETUP",
];
export const SSO_CONNECTION_STRATEGY: SsoConnectionStrategy[] = [
  "ADFS",
  "GOOGLE_APPS",
  "OIDC",
  "OKTA",
  "PINGFEDERATE",
  "SAMLP",
  "WAAD",
];
export const STYLE_AUTO_POPULATION_ATTRIBUTE: StyleAutoPopulationAttribute[] = [
  "CATEGORY",
  "DESCRIPTION",
  "EVALUATION_PROMPTS",
  "IMAGE_CAPTIONS",
  "INPUT_FILE_TYPES",
  "LABELS",
  "NAME",
  "PROMPT_SUFFIX",
];
export const STYLE_CAN_FORGE_FROM_STATUS: StyleCanForgeFromStatus[] = [
  "NO_CUSTOM_STYLE_ON_FREE_TIER",
  "NO_STYLE_IMPORT_PERMISSION",
  "NO_WORKSPACE_BLOCKS_IMPORTS",
  "NO_WORKSPACE_LINK_MISSING",
  "YES",
];
export const STYLE_CATEGORY: StyleCategory[] = [
  "ANIMATION",
  "CHARACTER",
  "EFFECT",
  "GENERAL",
  "OBJECT",
  "SCENE",
];
export const STYLE_CONTENT_TYPE: StyleContentType[] = [
  "BACKGROUND",
  "CHARACTER_MULTI",
  "CHARACTER_SINGLE",
  "ICONS_SYMBOLS",
  "ITEMS_ENVIRONMENT",
  "ITEMS_IN_GAME",
  "OTHER",
  "UI_ELEMENTS",
  "VEHICLES",
];
export const STYLE_FINETUNE_STATUS: StyleFinetuneStatus[] = [
  "ARCHIVED",
  "BUILDING",
  "CANCELLED",
  "COMPLETE",
  "DELETED",
  "FAILED",
  "INITIALIZING",
  "NEW",
];
export const STYLE_INPUT_FILE_TYPE: StyleInputFileType[] = [
  "BACK_IMAGE",
  "BOTTOM_IMAGE",
  "FRONT_IMAGE",
  "LEFT_IMAGE",
  "RIGHT_IMAGE",
  "TOP_IMAGE",
];
export const STYLE_STATUS: StyleStatus[] = [
  "ARCHIVED",
  "BUILDING",
  "CANCELLED",
  "COMPLETE",
  "DELETED",
  "DRAFT",
  "FAILED",
  "INITIALIZING",
];
export const STYLE_TYPE: StyleType[] = [
  "LAYER_TRAINED_CHECKPOINT",
  "MODEL_URL",
  "UPLOADED_CHECKPOINT",
  "UPLOADED_LORA",
];
export const STYLE_TYPE_FILTER: StyleTypeFilter[] = [
  "BASE_MODEL",
  "LAYER",
  "WORKSPACE",
];
export const THINKING_LEVEL: ThinkingLevel[] = ["HIGH", "MINIMAL"];
export const TRAINING_CATEGORY: TrainingCategory[] = [
  "CHARACTER",
  "OBJECT",
  "STYLE",
];
export const TRAINING_FRAMEWORK: TrainingFramework[] = [
  "AI_TOOLKIT",
  "DREAMBOOTH",
  "FAL",
  "KOHYA",
  "VOICE_CLONE",
  "VOICE_DESIGN",
];
export const TRAINING_METHOD: TrainingMethod[] = [
  "COMFY_WORKFLOW",
  "MODEL_URL",
  "TRAINED_EDIT_LORA",
  "TRAINED_LORA",
  "TRAINED_VOICE",
  "UPLOADED_LORA",
  "UPLOADED_VOICE_EMBEDDING",
];
export const TRAINING_RUN_STATUS: TrainingRunStatus[] = [
  "CANCELLED",
  "COMPLETE",
  "DELETED",
  "FAILED",
  "INITIALIZING",
  "RUNNING",
];
export const USAGE_LIMIT_PERIOD: UsageLimitPeriod[] = [
  "DAILY",
  "MONTHLY",
  "WEEKLY",
];
export const USAGE_LIMIT_STATUS: UsageLimitStatus[] = ["ACTIVE", "DISABLED"];
export const VECTORIZATION_COLOR_MODE: VectorizationColorMode[] = [
  "BINARY",
  "COLOR",
];
export const VECTORIZATION_MODE: VectorizationMode[] = ["POLYGON", "SPLINE"];
export const VIDEO_EFFECT_TYPE: VideoEffectType[] = [
  "ACTION_RUN",
  "AGENT_REVEAL",
  "ARC",
  "ARC_LEFT",
  "BASEBALL_KICK",
  "BASKETBALL_DUNKS",
  "BOXING",
  "BUCKLE_UP",
  "BUILDING_EXPLOSION",
  "BULLET_TIME",
  "CAR_CHASING",
  "CAR_EXPLOSION",
  "CAR_GRIP",
  "CATCH",
  "CATWALK",
  "CRANE_DOWN",
  "CRANE_OVER_THE_HEAD",
  "CRANE_UP",
  "CRASH_ZOOM_IN",
  "CRASH_ZOOM_OUT",
  "DIRTY_LENS",
  "DISINTEGRATION",
  "DOLLY_IN",
  "DOLLY_LEFT",
  "DOLLY_OUT",
  "DOLLY_RIGHT",
  "DOLLY_ZOOM_IN",
  "DOLLY_ZOOM_OUT",
  "DOUBLE_DOLLY",
  "DOWNHILL_POV",
  "DUTCH_ANGLE",
  "EYES_IN",
  "FACE_PUNCH",
  "FISHEYE",
  "FLYING",
  "FOCUS_CHANGE",
  "FPV_DRONE",
  "GENERAL",
  "GLAM",
  "HANDHELD",
  "HEAD_TRACKING",
  "HYPERLAPSE",
  "INVISIBLE",
  "JIB_DOWN",
  "JIB_UP",
  "KISS",
  "LAZY_SUSAN",
  "LENS_CRACK",
  "LENS_FLARE",
  "LEVITATION",
  "LOW_SHUTTER",
  "MELTING",
  "MOONWALK_LEFT",
  "MOONWALK_RIGHT",
  "MOUTH_IN",
  "OBJECT_POV",
  "ORBIT_360",
  "OVERHEAD",
  "PUSH_TO_GLASS",
  "RAP_FLEX",
  "ROBO_ARM",
  "SET_ON_FIRE",
  "SKATEBOARDING",
  "SKATEBOARD_GLIDE",
  "SKATEBOARD_KICKFLIP",
  "SKATEBOARD_OLLIE",
  "SKATE_CRUISE",
  "SKI_CARVING",
  "SKI_POWDER",
  "SNORRICAM",
  "SNOWBOARD_CARVING",
  "SNOWBOARD_POWDER",
  "SOUL_JUMP",
  "STATIC",
  "SUPER_DOLLY_IN",
  "SUPER_DOLLY_OUT",
  "TENTACLES",
  "THROUGH_OBJECT_IN",
  "THROUGH_OBJECT_OUT",
  "THUNDER_GOD",
  "TILT_DOWN",
  "TILT_UP",
  "TIMELAPSE_HUMAN",
  "TIMELAPSE_LANDSCAPE",
  "TURNING_METAL",
  "WHIP_PAN",
  "WIGGLE",
  "WIND_TO_FACE",
  "YOYO_ZOOM",
  "ZOOM_IN",
  "ZOOM_OUT",
];
export const WORKSPACE_DOMAIN_STATUS: WorkspaceDomainStatus[] = [
  "DELETED",
  "FAILED",
  "PENDING",
  "VERIFIED",
];
export const WORKSPACE_INTEGRATION_PROVIDER: WorkspaceIntegrationProvider[] = [
  "APPLOVIN",
  "GOOGLE_ADS",
  "GOOGLE_DRIVE",
  "META",
  "SENSORTOWER",
  "TIKTOK_ADS",
];
export const WORKSPACE_INTEGRATION_STATUS: WorkspaceIntegrationStatus[] = [
  "ACTIVE",
  "ERROR",
  "EXPIRED",
  "PENDING",
  "REVOKED",
];
export const WORKSPACE_MEMBERSHIP_STATUS: WorkspaceMembershipStatus[] = [
  "ACTIVE",
  "SUSPENDED",
];
export const WORKSPACE_ROLE: WorkspaceRole[] = [
  "ADMIN",
  "ARTIST",
  "ART_DIRECTOR",
  "EDITOR",
  "MEMBER",
  "SETTINGS_ADMIN",
];
export const WORKSPACE_USAGE_GROUP_BY: WorkspaceUsageGroupBy[] = [
  "MEASUREMENT_UNIT",
  "MODALITY",
  "MODE",
  "MODEL_ID",
  "MODIFIER_ID",
  "PRICE_CREATIVE_UNITS",
  "USER_ID",
];
